<template>
  <div class="consult">
    <ul>
      <li><img src="@/assets/images/about-img/Phone.png" alt="" /></li>
      <li>电话咨询</li>
    </ul>
    <ul>
      <li><img src="@/assets/images/about-img/QRCode.png" alt="" /></li>
      <li>立即咨询</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "consult",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.consult {
  @include inheritWH(85px, 198px);
  @include vertical;
  position: fixed;
  right: 0;
  top: 40%;
  z-index: 3;

  & > ul {
    background-color: $bg-color1;
    border-radius: 8px;
    border: 1px solid $bg-color2;
    @include vertical;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    cursor: pointer;
  }

  & > ul:first-child {
    @include inheritWH(percent, 79px);

    & > li:first-child {
      @include inheritWH(24px, 24px);
    }

    & > li:last-child {
      color: #606266;
      margin-top: 8px;
    }
  }

  & > ul:last-child {
    @include inheritWH(percent, 110px);

    & > li:first-child {
      @include inheritWH(68px, 68px);
    }

    & > li:last-child {
      color: $menu-active-color;
      margin-top: 10px;
    }
  }
}
</style>
